import Masonry from 'masonry-layout'

export default () => {
    const galleries = document.querySelectorAll('.gallery-holder');
    if(galleries && galleries.length > 0){
        for(let i=0,len=galleries.length; i<len; i++){
            const gallery = galleries[i]

            const msnry = new Masonry(gallery, {
                itemSelector: 'div',
            })

            setInterval(() => {
                msnry.layout();
            }, 1000);
        }
    }
}